import api from '@/services/api'
import AttributeMappingActions from './actions-types'
import AttributeMappingMutations from './mutations-types'

export default {

  [AttributeMappingActions.GET_ALL]({ commit }, options = {}) {
    return new Promise((resolve, reject) => {
      api.cdp.attribute_mapping
        .getAll(options)
        .then((response) => {
          commit(AttributeMappingMutations.SET_ATTRIBUTE_MAPPINGS, response.data.items)
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [AttributeMappingActions.SAVE_ATTRIBUTE_MAPPING]({ state }) {
    return new Promise((resolve, reject) => {
      let data = {}
      
      state.fields.forEach((item) => {
        let fieldName = item.name

        if (fieldName == 'customer_properties') {
          fieldName = 'customer_property_ids'
        }

        data[fieldName] = item.value
      })

      if (state.selectedAttributeMapping) {
        api.cdp.attribute_mapping
          .updateAttributeMapping(data, state.selectedAttributeMapping.attribute_mapping_id)
          .then((response) => {
            resolve(response.body)
          })
          .catch(() => reject())
      } else {
        api.cdp.attribute_mapping
          .createAttributeMapping(data)
          .then((response) => {
            resolve(response.body)
          })
          .catch(() => reject())
      }
    })
  },

  [AttributeMappingActions.DELETE_ATTRIBUTE_MAPPING]({ state }) {
    return new Promise((resolve, reject) => {
      api.cdp.attribute_mapping
        .deleteAttributeMapping(state.selectedAttributeMapping.attribute_mapping_id)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },
}